import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RiCloseCircleLine } from "react-icons/ri";
import ContactInput from "../Shared/ContactInput";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { RiImage2Line } from "react-icons/ri";
import { Button, Modal, Spinner } from "react-bootstrap";
import { customAction } from "../../actions/AuthActions";
import Select from "react-select";
import { notify } from "../../actions/notify";
import CustomAddBox from "../CustomTable/CustomAddBox";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DeleteModal from "../Shared/DeleteModal";
import NoData from "../Shared/NoData";
import {
  isEmail,
  isValidGst,
  truncateFilename,
  truncateString,
  salutationOptions,
  ckEditorConfiguration,
  preventInvalidNumberInput,
  reactBackendUrl,
} from "../../utils";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate } from "react-router-dom";

const paymentTermOptions = [
  { value: "IMMEDIATE", label: "IMMEDIATE" },
  { value: "7 DAYS", label: "7 DAYS" },
  { value: "15 DAYS", label: "15 DAYS" },
  { value: "21 DAYS", label: "21 DAYS" },
  { value: "30 DAYS", label: "30 DAYS" },
  { value: "45 DAYS", label: "45 DAYS" },
  { value: "60 DAYS", label: "60 DAYS" },
  { value: "90 DAYS", label: "90 DAYS" },
];
const projectTypeOptions = ["FIXED BUDGET", "HOURLY", "SUBSCRIPTION"];

const statusOptions = ["ACTIVE", "INACTIVE"];

const relationOptions = [
  "FATHER",
  "MOTHER",
  "BROTHER",
  "SPOUSE",
  "SISTER",
  "UNCLE",
  "AUNT",
  "FRIEND",
  "OTHER",
];
const prefixOptions = ["Mr.", "Ms.", "Mrs.", "Dr.", "Prof."];

const CustomAddModal = ({
  itemId,
  show: isOpen = true,
  onHide,
  title,
  projectId,
  fetchData,
  bankUrl,
  employeeId,
  clientId,
  milestoneCurrencySymbol,
  contacts,
  onCreated,
  layout = "sidepanel",
}) => {
  const { user, token } = useSelector((state) => state.authReducer);

  const navigate = useNavigate();
  const [id, setId] = useState(itemId);

  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [role, setRole] = useState("");
  const [team, setTeam] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("in");
  const [secondaryEmail, setSecondaryEmail] = useState("");
  const [gst, setGst] = useState("");
  const [tan, setTan] = useState("");
  const [vat, setVat] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [zohoProjectId, setZohoProjectId] = useState("");
  const [emergencySalutation, setEmergencySalutation] = useState("Mr.");

  const [emergencyName, setEmergencyName] = useState("");
  const [emergencyPhone, setEmergencyPhone] = useState("");
  const [emergencyCountryCode, setEmergencyCountryCode] = useState("in");
  const [emergencyRelation, setEmergencyRelation] = useState("");

  const [primaryName, setPrimaryName] = useState("");
  const [primaryNamePrefix, setPrimaryNamePrefix] = useState("Mr.");
  const [primaryDesignation, setPrimaryDesignation] = useState("");
  const [primaryPhone, setPrimaryPhone] = useState("");
  const [primaryCountryCode, setPrimaryCountryCode] = useState("in");
  const [primaryEmail, setPrimaryEmail] = useState("");
  const [primaryContact, setPrimaryContact] = useState(null);

  const [otherContacts, setOtherContacts] = useState([]);

  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [localAddress, setLocalAddress] = useState("");

  const [sameAsLocal, setSameAsLocal] = useState(true);

  const [permanentAddress, setPermanentAddress] = useState("");
  const [permanentCountry, setPermanentCountry] = useState("");
  const [permanentState, setPermanentState] = useState("");
  const [permanentCity, setPermanentCity] = useState("");
  const [permanentZipCode, setPermanentZipCode] = useState("");
  const [permanent, setPermanent] = useState("");

  const [bank, setBank] = useState("");
  const [branch, setBranch] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [swift, setSwift] = useState("");

  const [bankId, setBankId] = useState(null);

  const [costPerHour, setCostPerHour] = useState("");
  const [dob, setDob] = useState("");
  const [doj, setDoj] = useState("");
  const [dol, setDol] = useState("");
  const [hsn, setHsn] = useState("");
  const [reasonForLeaving, setReasonForLeaving] = useState("");
  const [clientType, setClientType] = useState("COMPANY");
  const [status, setStatus] = useState({
    value: "ACTIVE",
    label: "ACTIVE",
  });
  const [description, setDescription] = useState("");
  const [project, setProject] = useState(projectId ? projectId : "");

  const [officeLocation, setOfficeLocation] = useState("");
  const [bankDetails, setBankDetails] = useState("");
  const [client, setClient] = useState("");
  const [ongoing, setOngoing] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState(
    milestoneCurrencySymbol ? milestoneCurrencySymbol : ""
  );
  const [projectType, setProjectType] = useState({
    value: "FIXED BUDGET",
    label: "FIXED BUDGET",
  });
  const [cost, setCost] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [paymentTerms, setPaymentTerms] = useState({
    value: "IMMEDIATE",
    label: "IMMEDIATE",
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [showTeam, setShowTeam] = useState(false);
  const [show, setShow] = useState(false);
  const fileInputRef = useRef(null);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [leaveType, setLeaveType] = useState("");
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [saveAddLoading, setSaveAddLoading] = useState(false);

  const [roleOptions, setRoleOptions] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [filteredStateOptions, setFilteredStateOptions] = useState([]);
  const [filteredPermanentStateOptions, setFilteredPermanentStateOptions] =
    useState([]);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [enableDelayCharges, setEnableDelayCharges] = useState(false)
  const [dailyInterestRate, setDailyInterestRate] = useState(0)
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [send, setSend] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const handleCheckboxChange = (contact) => {
    setSelectedContacts((prev) => {
      if (prev.some((item) => item.id === contact.id)) {
        return prev.filter((item) => item.id !== contact.id);
      } else {
        return [...prev, contact];
      }
    });
  };
  useEffect(() => {
    if (title === "Employee" || title === 'Team Member') {
      fetchCountryOptions();
      fetchStateOptions();
      fetchRoleOptions();
      fetchTeamOptions();
      fetchCurrencyOptions();
      if (id) {
        setLoading(true);
        fetchEmployeeDetails();
      }
    }
    if (title === "Project") {
      fetchClientOptions();
      fetchCurrencyOptions();
    }
    if (title === "Client") {
      if (id) {
        fetchClientDetails();
      }
      fetchCountryOptions();
      fetchStateOptions();
      fetchBankOptions();
      fetchOfficeOptions();
    }
    if (title === "Milestone") {
      if (id) {
        fetchMilestoneDetails();
      }
      fetchCurrencyOptions();
    }
    if (title === "MoM" && id) {
      fetchMoMDetails();
    }
    if (title === "Project" && id) {
      fetchProjectDetails();
    }
    if (title === "Vendor") {
      fetchCountryOptions();
      fetchOfficeOptions();
      fetchStateOptions();
      if (id) {
        fetchVendorDetails();
      }
    }

    if (title === "Bank Account" && id) {
      fetchBankAccountDetails();
    }
    if (title === "New Bank" && employeeId && id && bankUrl) {
      fetchBankAccountDetails(`${bankUrl}/bank/`);
    }
    if (title === "New Office") {
      fetchCountryOptions();
      fetchStateOptions();
      if (id) {
        fetchOfficeDetails();
      }
    }
    if (title === "Leave") {
      if (id) {
        fetchLeaveDetails();
      }
      if (user?.is_admin || user?.is_project_manager) {
        fetchEmployees();
      }
      fetchLeaveTypeOptions();
    }
  }, []);

  const ckEditorImageConfiguration = {
    toolbar: {
      items: [
        "undo",
        "redo",
        "|",
        "heading",
        "|",
        "fontfamily",
        "fontsize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "strikethrough",
        "subscript",
        "superscript",
        "code",
        "|",
        "link",
        "blockQuote",
        "codeBlock",
        "|",
        "bulletedList",
        "numberedList",
        "todoList",
        "outdent",
        "indent",
        "|",
        "imageUpload",
      ],
      shouldNotGroupWhenFull: false,
    },
    ckfinder: {
      uploadUrl: `${reactBackendUrl}/ckeditor/upload/`,
    },
  };

  const fetchCurrencyOptions = async () => {
    const response = await customAction(
      `country/currency?page_size=all`,
      "fetch",
      null,
      token,
      "Currency Options"
    );
    if (response) {
      setCurrencyOptions(response);
    }
  };

  const fetchCountryOptions = async () => {
    const response = await customAction(
      `country/country?page_size=all`,
      "fetch",
      null,
      token,
      "Currency Options"
    );
    if (response) {
      setCountryOptions(response);
    }
  };

  const fetchStateOptions = async () => {
    const response = await customAction(
      `country/state?page_size=all`,
      "fetch",
      null,
      token,
      "Currency Options"
    );
    if (response) {
      setStateOptions(response);
      setFilteredStateOptions(response);
      setFilteredPermanentStateOptions(response);
    }
  };

  const fetchOfficeOptions = async () => {
    const response = await customAction(
      `office/office?is_for_invoice=false`,
      "fetch",
      null,
      token,
      "Office Options"
    );
    if (response) {
      setOfficeOptions(response?.results);
    }
  };

  const fetchBankOptions = async () => {
    const response = await customAction(
      `office/bank?is_for_invoice=false`,
      "fetch",
      null,
      token,
      "Office Bank Options"
    );
    if (response) {
      setBankOptions(response?.results);
    }
  };

  const fetchOfficeDetails = async () => {
    const response = await customAction(
      `office/office/${id}`,
      "fetch",
      null,
      token,
      "Office Details"
    );
    if (response) {
      setFName(response?.name);
      setGst(response?.gst);
      setAddress(response?.address_array?.address);
      setCountry({
        value: response?.address_array?.country,
        label: response?.address_array?.country_name,
      });
      setState({
        value: response?.address_array?.state,
        label: response?.address_array?.state_name,
      });
      setCity(response?.address_array?.city);
      setZipCode(response?.address_array?.zipcode);
    }
  };

  const fetchBankAccountDetails = async (url) => {
    const response = await customAction(
      url ? `${url}${itemId}` : `office/bank/${id}`,
      "fetch",
      null,
      token,
      "Bank Details"
    );
    if (response) {
      setBank(response?.name);
      setBranch(response?.branch);
      setIfsc(response?.ifsc_code);
      setAccountName(response?.account_holder_name);
      setAccountNumber(response?.account_number);
      setSwift(response?.swift_bic);
    }
  };

  const fetchProjectDetails = async () => {
    const response = await customAction(
      `project/project/${id}`,
      "fetch",
      null,
      token,
      "Project Details"
    );
    if (response) {
      setFName(response?.title);
      setClient({
        value: response?.client,
        label: response?.client_array?.name,
      });
      setStartDate(response?.start_date);
      setOngoing(response?.ongoing);
      setEndDate(response?.end_date);
      response?.description && setDescription(response?.description);
      setProjectType({
        value: response?.project_type,
        label: response?.project_type,
      });
      setCurrency({
        value: response?.currency?.id,
        label: response?.currency?.code,
      });
      setCost(response?.cost);
      setPaymentTerms({
        value: paymentTermOptions?.filter(
          (item) => item?.label === response?.payment_terms
        ).value,
        label: response?.payment_terms,
      });
      setZohoProjectId(response?.zoho_project_id);
      setHsn(response?.hsn);
    }
  };

  const fetchMilestoneDetails = async () => {
    const response = await customAction(
      `project/milestone/${id}`,
      "fetch",
      null,
      token,
      "Milestone Details"
    );
    if (response) {
      setFName(response?.title ? response?.title : "");
      setStatus({
        value: response?.status,
        label: response?.status,
      });
      setStartDate(response?.start_date ? response?.start_date : "");
      setEndDate(response?.end_date ? response?.end_date : "");
      setDescription(response?.description ? response?.description : "");
      setProject(response?.project);
      setCost(response?.cost ? response?.cost : "");
      setCurrencySymbol(
        response?.currency?.code
          ? response?.currency?.code
          : milestoneCurrencySymbol
            ? milestoneCurrencySymbol
            : ""
      );
    }
  };

  const fetchMoMDetails = async () => {
    const response = await customAction(
      `project/mom/${id}`,
      "fetch",
      null,
      token,
      "MoM Details"
    );
    if (response) {
      setFName(response?.title ? response?.title : "");
      setStartDate(response?.date ? response?.date : "");
      setDescription(response?.description ? response?.description : "");
      setProject(response?.project);
      setSend(response?.send_to_customer ? response?.send_to_customer : false);
    }
  };

  const fetchClientDetails = async () => {
    const response = await customAction(
      `client/client/${id}`,
      "fetch",
      null,
      token,
      "Client Details"
    );
    if (response) {
      setClientType(response?.client_type);
      setFName(response?.name);
      setGst(response?.gst_number);
      setTan(response?.tan_number);
      setVat(response?.vat_number);
      setWebsiteUrl(response?.website_url);
      setSelectedImage(response?.company_logo);
      setAddress(response?.company_address_array?.address);
      setCountry({
        value: response?.company_address_array?.country,
        label: response?.company_address_array?.country_name,
      });
      setState({
        value: response?.company_address_array?.state,
        label: response?.company_address_array?.state_name,
      });
      setCity(response?.company_address_array?.city);
      setZipCode(response?.company_address_array?.zipcode);
      setLocalAddress(response?.company_address);
      setSameAsLocal(response?.same_as_address);
      setPermanent(response?.billing_address);
      setPermanentAddress(response?.billing_address_array?.address);
      response?.billing_address_array?.country &&
        setPermanentCountry({
          value: response?.billing_address_array?.country,
          label: response?.billing_address_array?.country_name,
        });
      response?.billing_address_array?.state &&
        setPermanentState({
          value: response?.billing_address_array?.state,
          label: response?.billing_address_array?.state_name,
        });
      setPermanentCity(response?.billing_address_array?.city);
      setPermanentZipCode(response?.billing_address_array?.zipcode);
      const primaryContactData = response?.contacts_array?.find(
        (item) => item?.contact_type === "PRIMARY"
      );
      setPrimaryContact(primaryContactData?.id);
      setPrimaryNamePrefix(
        primaryContactData?.prefix ? primaryContactData?.prefix : "Mr."
      );
      setPrimaryName(primaryContactData?.name);
      setPrimaryPhone(primaryContactData?.phone);
      setPrimaryCountryCode(
        primaryContactData?.country_code
          ? primaryContactData?.country_code
          : "in"
      );
      setPrimaryEmail(primaryContactData?.email);
      setPrimaryDesignation(primaryContactData?.designation);

      const updatedOtherContacts = response?.contacts_array
        ?.filter((item) => item?.contact_type !== "PRIMARY")
        ?.map((item) => ({
          ...item,
          countryCode: item?.country_code,
          prefix: item?.prefix,
        }));

      setOtherContacts(updatedOtherContacts);
      setOfficeLocation({
        value: response?.office_location,
        label: response?.office_location_array?.name,
      });
      setBankDetails({
        value: response?.office_bank_details,
        label: response?.office_bank_details_array?.name,
      });
      setEnableDelayCharges(response?.enable_delay_charges)
      setDailyInterestRate(response?.daily_interest_rate)
    }
  };

  const fetchVendorDetails = async () => {
    const response = await customAction(
      `vendor/vendor/${id}`,
      "fetch",
      null,
      token,
      "Vendor Details"
    );
    if (response) {
      setClientType(response?.vendor_type);
      setFName(response?.name);
      setGst(response?.gst_number);
      setTan(response?.pan_number);
      setEmail(response?.email);
      setSecondaryEmail(response?.secondary_email);

      setPhone(response?.phone);
      setCountryCode(response?.country_code ? response?.country_code : "in");

      setAddress(response?.address_array?.address);
      setCountry({
        value: response?.address_array?.country,
        label: response?.address_array?.country_name,
      });
      setState({
        value: response?.address_array?.state,
        label: response?.address_array?.state_name,
      });
      setCity(response?.address_array?.city);
      setZipCode(response?.address_array?.zipcode);
      setLocalAddress(response?.company_address);

      setBank(response?.vendor_bank?.[0]?.name);
      setBranch(response?.vendor_bank?.[0]?.branch);
      setIfsc(response?.vendor_bank?.[0]?.ifsc_code);
      setAccountName(response?.vendor_bank?.[0]?.account_holder_name);
      setAccountNumber(response?.vendor_bank?.[0]?.account_number);
      setBankId(response?.vendor_bank?.[0]?.id);
      setSwift(response?.vendor_bank?.[0]?.swift_bic);
      response?.office_location && setOfficeLocation({
        value: response?.office_location,
        label: response?.office_location_array?.name,
      });
    }
  };

  const fetchEmployeeDetails = async () => {
    const response = await customAction(
      `employee/employee/${id}`,
      "fetch",
      null,
      token,
      "Employee Details"
    );
    if (response) {
      setFName(response?.first_name);
      setLName(response?.last_name ? response?.last_name : "");
      setRole({
        value: response?.role,
        label: response?.role_name,
      });
      setSecondaryEmail(response?.secondary_email);
      setTeam({
        value: response?.team_array?.id,
        label: response?.team_array?.name,
      });
      setEmergencyName(
        response?.emergency_contact_name ? response?.emergency_contact_name : ""
      );
      setEmergencyPhone(response?.emergency_contact_phone);
      setEmergencyCountryCode(
        response?.emergency_contact_country_code
          ? response?.emergency_contact_country_code
          : "in"
      );
      setEmergencyRelation({
        value: response?.emergency_contact_relation,
        label: response?.emergency_contact_relation,
      });

      setAddress(response?.local_address_array?.address);
      setCountry({
        value: response?.local_address_array?.country,
        label: response?.local_address_array?.country_name,
      });
      setState({
        value: response?.local_address_array?.state,
        label: response?.local_address_array?.state_name,
      });
      setCity(response?.local_address_array?.city);
      setZipCode(response?.local_address_array?.zipcode);
      setLocalAddress(response?.local_address);

      setPermanent(response?.permanent_address);

      setPermanentAddress(response?.permanent_address_array?.address);
      setPermanentCountry({
        value: response?.permanent_address_array?.country,
        label: response?.permanent_address_array?.country_name,
      });
      setPermanentState({
        value: response?.permanent_address_array?.state,
        label: response?.permanent_address_array?.state_name,
      });
      setPermanentCity(response?.permanent_address_array?.city);
      setPermanentZipCode(response?.permanent_address_array?.zipcode);
      setSameAsLocal(response?.same_as_local);

      setSelectedImage(response?.image);

      setBank(response?.employee_banks?.[0]?.name);
      setBranch(response?.employee_banks?.[0]?.branch);
      setIfsc(response?.employee_banks?.[0]?.ifsc_code);
      setAccountName(response?.employee_banks?.[0]?.account_holder_name);
      setAccountNumber(response?.employee_banks?.[0]?.account_number);
      setBankId(response?.employee_banks?.[0]?.id);
      setSwift(response?.employee_banks?.[0]?.swift_bic);
      setLoading(false);
    }
  };

  const fetchClientOptions = async () => {
    const response = await customAction(
      "project/client?page_size=all",
      "fetch",
      null,
      token,
      "Role option"
    );
    if (response) {
      setClientOptions(response);
      if (clientId && !itemId) {
        setClient({
          value: clientId,
          label: response?.filter((item) => item?.id == clientId)?.[0]?.name,
        });
      }
    }
  };

  const fetchRoleOptions = async () => {
    const response = await customAction(
      "employee/role?page_size=all",
      "fetch",
      null,
      token,
      "Role option"
    );
    if (response) {
      setRoleOptions(response);
    }
  };

  const fetchTeamOptions = async () => {
    const response = await customAction(
      "employee/team?page_size=all",
      "fetch",
      null,
      token,
      "Team options"
    );
    if (response) {
      setTeamOptions(response);
    }
  };

  const fetchLeaveTypeOptions = async () => {
    const resp = await customAction(
      `leave/leave-policy-by-type-current`,
      "fetch",
      null,
      token,
      "Leave type"
    );
    if (resp) {
      // console.log(resp);
      const options = resp.map((item) => ({
        value: item.id,
        label: item.leave_type_details?.name,
        leave_type_details: item?.leave_type_details,
        minimum_notice_days: item?.minimum_notice_days,
      }));

      setLeaveTypeOptions(options);
    }
  };

  const fetchEmployees = async () => {
    const response = await customAction(
      "employee/employee?page_size=all&status=ACTIVE",
      "fetch",
      null,
      token,
      "Employee option"
    );
    if (response) {
      const options = response.map((item) => ({
        value: item.id,
        label: item?.first_name + " " + item?.last_name,
      }));

      setEmployeeOptions(options);
    }
  };

  const fetchLeaveDetails = async () => {
    const resp = await customAction(
      `leave/leave/${itemId}`,
      "fetch",
      null,
      token
    );
    if (resp) {
      setDescription(resp?.description);
      setStartDate(resp?.start_date);
      setEndDate(resp?.end_date);
      setLeaveType({
        value: resp?.leave_type_by_policy,
        label: resp?.leave_type_details?.name,
        leave_type_details: resp?.leave_type_details,
        minimum_notice_days:
          resp?.leave_type_by_policy_detials?.minimum_notice_days,
      });
      if (user?.is_admin || user?.is_project_manager) {
        let employee_details = resp?.employee_details;
        setEmployee({
          value: resp?.employee,
          label:
            employee_details?.first_name + " " + employee_details?.last_name,
        });
      }
      setSelectedImage(resp?.file ? resp?.file : "");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const handleSetSameAsLocal = () => {
    setPermanentAddress(address);
    setPermanentCountry(country);
    setPermanentState(state);
    setPermanentCity(city);
    setPermanentZipCode(zipCode);
    setSameAsLocal(true);
  };

  const handleDeleteOtherContact = async (index) => {
    const itemToDelete = otherContacts[index];
    if (itemToDelete && itemToDelete.id) {
      const response = await customAction(
        `client/contact/${itemToDelete?.id}`,
        "delete",
        null,
        token,
        "Contact"
      );
    }
    const updatedItems = otherContacts.filter((item, i) => i !== index);
    if (!itemToDelete?.id) {
      notify("Contact deleted successfully", "success");
    }
    setOtherContacts(updatedItems);
    setShowDelete(false);
  };

  const handleAddOtherContact = async () => {
    if (otherContacts.length === 0) {
      if (
        primaryName &&
        primaryEmail &&
        primaryName !== "" &&
        primaryEmail !== ""
      ) {
        setOtherContacts([
          {
            prefix: "Mr.",
            name: null,
            designation: null,
            phone: "",
            countryCode: "in",
            email: null,
          },
        ]);
      } else {
        notify("Please add name and email for primary contact", "warning");
      }
    } else {
      const lastItem = otherContacts[otherContacts.length - 1];
      if (lastItem && lastItem.name && lastItem.email) {
        setOtherContacts((prevItems) => [
          ...prevItems,
          {
            prefix: "Mr.",
            name: null,
            designation: null,
            phone: "",
            countryCode: "in",
            email: null,
          },
        ]);
      } else {
        notify(
          "Please add name and email previous contact before adding a new one.",
          "warning"
        );
      }
    }
  };

  const handleContact = async (
    prefix,
    name,
    email,
    phone,
    countryCode,
    designation,
    id,
    clientId,
    contactType = "PRIMARY",
    showNotify = true
  ) => {
    const formData = new FormData();

    formData.append("prefix", prefix);
    formData.append("name", name);
    email && formData.append("email", email);
    phone && formData.append("phone", phone);
    formData.append("country_code", countryCode);
    formData.append("client", clientId);
    formData.append("contact_type", contactType);
    designation && formData.append("designation", designation);

    const response = await customAction(
      id ? `client/contact/${id}/` : "client/contact/",
      id ? "patch" : "post",
      formData,
      token,
      "Contact",
      false,
      showNotify
    );
    if (response) {
      return response;
    }
  };

  const handleAddress = async (
    address,
    country,
    state,
    city,
    zipcode,
    id,
    showNotify = true
  ) => {
    const formData = new FormData();
    address && formData.append("address", address);
    country && formData.append("country", country);
    state && formData.append("state", state);
    city && formData.append("city", city);
    zipcode && formData.append("zipcode", zipcode);
    const response = await customAction(
      id ? `address/address/${id}/` : `address/address/`,
      id ? "patch" : "post",
      formData,
      token,
      "Address add update",
      false,
      showNotify
    );
    if (response) {
      return response;
    }
  };

  const handleAddBank = async (
    type,
    empId,
    itemId,
    url = bankUrl ? bankUrl : "employee",
    showNotify = true
  ) => {
    // console.log(empId, id);
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    if (bank && bank !== "") {
      const formData = new FormData();
      bank && formData.append("name", bank);
      branch && formData.append("branch", branch);
      ifsc && formData.append("ifsc_code", ifsc);
      accountNumber && formData.append("account_number", accountNumber);
      accountName && formData.append("account_holder_name", accountName);
      formData.append(`${url}`, empId);
      swift && formData.append("swift_bic", swift);

      const response = await customAction(
        itemId ? `${url}/bank/${itemId}/` : `${url}/bank/`,
        itemId ? "patch" : "post",
        formData,
        token,
        "Bank",
        false,
        showNotify
      );
      if (response) {
        if (type === "saveadd") {
          setBank("");
          setBranch("");
          setIfsc("");
          setAccountNumber("");
          setAccountName("");
          setId(null);
        } else {
          onHide();
        }
        fetchData();
        setSaveLoading(false);
        setSaveAddLoading(false);
        return response;
      }
    } else {
      notify("Add bank to continue");
    }
    setSaveLoading(false);
    setSaveAddLoading(false);
  };

  const handleLeave = async (id, type) => {
    if ((user?.is_admin || user?.is_project_manager) && !employee?.value) {
      return notify("Please select a employee", "warning");
    }
    if (!leaveType?.value || leaveType === "")
      return notify("Leave type is required");

    if (!startDate || startDate === "")
      return notify("From date is required", "warning");

    if (!endDate || endDate === "")
      return notify("Till date is required", "warning");

    if (new Date(endDate) < new Date(startDate)) {
      return notify("End date cannot be earlier than start date", "warning");
    }

    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }

    const formData = new FormData();
    formData.append("leave_type_by_policy", leaveType?.value);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("description", description);
    selectedImage &&
      typeof selectedImage !== "string" &&
      formData.append("file", truncateFilename(selectedImage));

    if ((user?.is_admin || user?.is_project_manager) && employee?.value) {
      formData.append("employee", employee?.value);
    }

    const response = await customAction(
      id ? `leave/leave/${id}/` : "leave/leave/",
      id ? "put" : "post",
      formData,
      token,
      "Leave",
      true
    );
    if (response) {
      if (type === "saveadd") {
      } else {
        onHide();
      }
      fetchData();
      setSaveLoading(false);
      setSaveAddLoading(false);
      // console.log(response);
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleTeam = async (id) => {
    const formData = new FormData();
    const employeeArray = teamOptions?.find(
      (item) => item?.id === team?.value
    ).employees;
    employeeArray.push(id ? id : id);
    // console.log(employeeArray);
    formData.append("employees", employeeArray);
    const response = await customAction(
      `employee/team/${team?.value}/`,
      "put",
      { name: team?.label, employees: employeeArray },
      token,
      "Team",
      false,
      false
    );
    if (response) {
      onHide();
      fetchData();
    }
  };

  const handleAddOffice = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    if (fName && isValidGst(gst) && country?.value && state?.value) {
      let localResponse = null;

      if (address || country?.value || state?.value || city || zipCode) {
        const response = await handleAddress(
          address,
          country?.value,
          state?.value,
          city,
          zipCode,
          localAddress,
          false
        );
        localResponse = response;
      }
      const formData = new FormData();
      formData.append("name", fName);
      formData.append("gst", gst);
      if (localAddress || localResponse) {
        formData.append(
          "address",
          localResponse ? localResponse?.id : localAddress
        );
      }
      const response = await customAction(
        id ? `office/office/${id}/` : `office/office/`,
        id ? "patch" : "post",
        formData,
        token,
        "Office"
      );
      if (response) {
        // console.log(response);
        if (type === "saveadd") {
          setFName("");
          setAddress("");
          setCountry("");
          setState("");
          setCity("");
          setZipCode("");
          setGst("");
          setId(null);
        } else {
          onHide();
        }
        fetchData();
      }
    } else {
      if (!fName) {
        notify("Please enter office title", "warning");
      } else if (!isValidGst(gst)) {
        notify("Please enter a valid gst", "warning");
      } else if (!country?.value) {
        notify("Please select country", "warning");
      } else if (!state?.value) {
        notify("Please select state", "warning");
      }
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleAddEmployee = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    if (
      fName &&
      fName !== "" &&
      lName &&
      lName !== "" &&
      email &&
      email !== "" &&
      role &&
      role?.value &&
      team &&
      team?.value &&
      doj &&
      doj !== "" &&
      dob &&
      dob !== "" &&
      phone &&
      phone !== "" &&
      isEmail(email) &&
      (isEmail(secondaryEmail) || !secondaryEmail)
    ) {
      if (bankId ? bank && bank !== "" : true) {
        let localResponse = null;
        let permanentResponse = null;
        if (address || country?.value || state?.value || city || zipCode) {
          const response = await handleAddress(
            address,
            country?.value,
            state?.value,
            city,
            zipCode,
            localAddress,
            false
          );
          localResponse = response;
        }
        if (
          permanentAddress ||
          permanentCountry?.value ||
          permanentCity ||
          permanentState?.value ||
          permanentZipCode
        ) {
          const response = await handleAddress(
            permanentAddress,
            permanentCountry?.value,
            permanentState?.value,
            permanentCity,
            permanentZipCode,
            permanent,
            false
          );
          permanentResponse = response;
        }
        const formData = new FormData();

        formData.append("first_name", fName);
        formData.append("last_name", lName);
        role && role?.value && formData.append("role", role?.value);
        formData.append("email", email);
        secondaryEmail && formData.append("secondary_email", secondaryEmail);

        formData.append("phone", phone);
        formData.append("country_code", countryCode);
        team && team?.value && formData.append("team", team?.value);

        costPerHour && formData.append("cost_per_hour", costPerHour);
        dob && formData.append("dob", dob);
        doj && formData.append("date_of_joining", doj);
        dol && formData.append("date_of_leaving", dol);
        reasonForLeaving &&
          formData.append("reason_for_leaving", reasonForLeaving);

        user?.is_admin && formData.append("status", status?.value);
        (localAddress || localResponse) &&
          formData.append(
            "local_address",
            localResponse ? localResponse?.id : localAddress
          );
        (permanent || permanentResponse) &&
          formData.append(
            "permanent_address",
            permanentResponse
              ? permanentResponse?.id
              : permanent
                ? permanent
                : ""
          );
        formData.append("same_as_local", sameAsLocal);
        emergencyName &&
          formData.append("emergency_contact_name", emergencyName);
        emergencyPhone &&
          formData.append("emergency_contact_phone", emergencyPhone);
        emergencyCountryCode &&
          formData.append(
            "emergency_contact_country_code",
            emergencyCountryCode
          );
        emergencyRelation &&
          emergencyRelation?.value &&
          formData.append(
            "emergency_contact_relation",
            emergencyRelation?.value
          );

        selectedImage &&
          typeof selectedImage !== "string" &&
          formData.append("image", truncateFilename(selectedImage));

        const response = await customAction(
          id ? `employee/employee/${id}/` : "employee/employee/",
          id ? "patch" : "post",
          formData,
          token,
          "Employee" || "Team Member",
          true
        );
        if (response) {
          if (bank || branch || ifsc || accountName || accountNumber) {
            const bankResponse = handleAddBank(
              type,
              response?.data?.id,
              response?.data?.employee_banks?.[0]?.id,
              "employee",
              false
            );
          }
          if (
            !bank &&
            !branch &&
            !ifsc &&
            accountName &&
            accountNumber &&
            response?.data?.employee_banks?.[0]?.id
          ) {
            const bankDeleteResponse = customAction(
              `employee/bank/${response?.data?.employee_banks?.[0]?.id}`,
              "delete",
              null,
              token,
              "Bank",
              false,
              false
            );
          }

          if (type === "saveadd") {
            setFName("");
            setLName("");
            setRole("");
            setEmail("");
            setSecondaryEmail("");
            setPhone("");
            setCountryCode("in");
            setCostPerHour("");
            setDob("");
            setDoj("");
            setTeam("");
            setSameAsLocal(false);
            setEmergencyName("");
            setEmergencyPhone("");
            setEmergencyCountryCode("in");
            setEmergencyRelation("");

            setAddress("");
            setCountry("");
            setState("");
            setCity("");
            setZipCode("");
            setLocalAddress("");

            setPermanent("");
            setPermanentAddress("");
            setPermanentCountry("");
            setPermanentState("");
            setPermanentCity("");
            setPermanentZipCode("");

            setSelectedImage("");
            setBank("");
            setBranch("");
            setIfsc("");
            setAccountNumber("");
            setAccountName("");
            setId(null);
          } else {
            onHide();
          }
          fetchData();
        }
      } else {
        notify("Bank is required");
      }
    } else {
      if (!fName || fName === "") {
        notify("First name is required", "warning");
      } else if (!lName || lName === "") {
        notify("Last name is required", "warning");
      } else if (!role || !role?.value) {
        notify("Role is required", "warning");
      } else if (!team || !team?.value) {
        notify("Team is required", "warning");
      } else if (!email || email === "") {
        notify("Email is required", "warning");
      } else if (!isEmail(email)) {
        notify("Please enter a valid email", "warning");
      } else if (secondaryEmail && !isEmail(secondaryEmail)) {
        notify("Please enter a valid secondary  email", "warning");
      } else if (!phone || phone === "") {
        notify("Phone is required", "warning");
      } else if (!dob || dob === "") {
        notify("Date of birth is required", "warning");
      } else if (!doj || doj === "") {
        notify("Date of joining is required", "warning");
      }
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleAddClient = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    let localResponse = null;
    let permanentResponse = null;
    if (
      fName &&
      fName !== "" &&
      officeLocation?.value &&
      (country?.label !== "India" || !gst || isValidGst(gst)) &&
      bankDetails?.value &&
      permanentCountry &&
      permanentState &&
      permanentAddress &&
      address &&
      country &&
      state &&
      primaryName &&
      primaryEmail
    ) {
      if (address || country?.value || state?.value || city || zipCode) {
        const response = await handleAddress(
          address,
          country?.value,
          state?.value,
          city,
          zipCode,
          localAddress,
          false
        );
        localResponse = response;
      }
      if (
        permanent &&
        !permanentAddress &&
        !permanentCountry?.value &&
        !permanentCity &&
        !permanentState?.value &&
        !permanentZipCode
      ) {
        // console.log("950", permanent);
        const response = await customAction(
          `address/address/${permanent}/`,
          "delete",
          null,
          token,
          "Contact",
          false,
          false
        );
        if (response) {
          setPermanent(null);
        }
      }
      if (
        permanentAddress ||
        permanentCountry?.value ||
        permanentCity ||
        permanentState?.value ||
        permanentZipCode
      ) {
        const response = await handleAddress(
          permanentAddress,
          permanentCountry?.value,
          permanentState.value,
          permanentCity,
          permanentZipCode,
          permanent,
          false
        );
        permanentResponse = response;
      }
      const formData = new FormData();
      formData.append("client_type", clientType);
      formData.append("name", fName);
      formData.append("tan_number", tan);
      formData.append("vat_number", vat);
      formData.append("gst_number", gst);
      formData.append("website_url", websiteUrl);
      selectedImage &&
        typeof selectedImage !== "string" &&
        formData.append("company_logo", truncateFilename(selectedImage));
      officeLocation?.value &&
        formData.append("office_location", officeLocation?.value);
      bankDetails?.value &&
        formData.append("office_bank_details", bankDetails?.value);
      formData.append("enable_delay_charges", enableDelayCharges)
      formData.append("daily_interest_rate", enableDelayCharges ? dailyInterestRate : 0)
      if (localAddress || localResponse) {
        formData.append(
          "company_address",
          localResponse ? localResponse?.id : localAddress
        );
      }

      if (permanent || permanentResponse) {
        if (
          permanent &&
          !permanentAddress &&
          !permanentCountry?.value &&
          !permanentCity &&
          !permanentState?.value &&
          !permanentZipCode
        ) {
          // console.log("dele");
        } else {
          formData.append(
            "billing_address",
            permanentResponse
              ? permanentResponse?.id
              : permanent
                ? permanent
                : ""
          );
        }
      }
      formData.append("same_as_address", sameAsLocal);
      const response = await customAction(
        id ? `client/client/${id}/` : "client/client/",
        id ? "patch" : "post",
        formData,
        token,
        "Client",
        true
      );
      if (response) {
        // console.log(response);
        if (primaryName || primaryPhone || primaryEmail || primaryDesignation) {
          const contactResponse = await handleContact(
            primaryNamePrefix,
            primaryName,
            primaryEmail,
            primaryPhone,
            primaryCountryCode,
            primaryDesignation,
            primaryContact,
            response?.data?.id,
            "PRIMARY",
            false
          );
        }
        if (otherContacts?.length > 0) {
          for (const contact of otherContacts) {
            const contactResponse = await handleContact(
              contact?.prefix,
              contact?.name,
              contact?.email,
              contact?.phone,
              contact?.countryCode,
              contact?.designation,
              contact?.id,
              response?.data?.id,
              "OTHERS",
              false
            );
          }
        }
        if (type === "saveadd") {
          setClientType("COMPANY");
          setFName("");
          setGst("");
          setTan("");
          setVat("");
          setWebsiteUrl("");
          setSelectedImage("");
          setSameAsLocal(false);

          setAddress("");
          setCountry("");
          setState("");
          setCity("");
          setZipCode("");
          setLocalAddress("");

          setPermanent("");
          setPermanentAddress("");
          setPermanentCountry("");
          setPermanentState("");
          setPermanentCity("");
          setPermanentZipCode("");

          setPrimaryContact("");
          setPrimaryNamePrefix("");
          setPrimaryName("");
          setPrimaryPhone("");
          setPrimaryCountryCode("in");
          setPrimaryEmail("");
          setPrimaryDesignation("");
          setOfficeLocation("");
          setBankDetails("");

          setOtherContacts([]);
          setId(null);
        } else {
          onHide();
        }
        fetchData();
      }
    } else {
      // console.log("1244", isValidGst(gst));
      if (!fName || fName === "") {
        notify("Company name is required ", "warning");
      } else if (country?.label === "India" && gst && !isValidGst(gst)) {
        notify("Please enter a valid gst", "warning");
      } else if (!address) {
        notify("Please enter company address", "warning");
      } else if (!country) {
        notify("Please enter company address country", "warning");
      } else if (!state) {
        notify("Please enter company address state", "warning");
      } else if (!permanentAddress) {
        notify("Please enter billing address", "warning");
      } else if (!permanentCountry) {
        notify("Please enter billing address country", "warning");
      } else if (!permanentState) {
        notify("Please enter billing address state", "warning");
      } else if (!primaryName) {
        notify("Please add primary contact name", "warning");
      } else if (!primaryEmail) {
        notify("Please add primary contact email", "warning");
      } else if (!officeLocation?.value) {
        notify("Office Location is required ", "warning");
      } else if (!bankDetails?.value) {
        notify("Bank Details is required ", "warning");
      }
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleAddVendor = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    let localResponse = null;
    const trimmedName = (fName || "").trim();
    const trimmedGst = (gst || "").trim().toUpperCase();

    let officeId = officeLocation?.value;
    if (!officeId) {
      const fallbackOffice = officeOptions?.[0];
      if (fallbackOffice?.id) {
        officeId = fallbackOffice.id;
        setOfficeLocation({ value: fallbackOffice.id, label: fallbackOffice.name });
      }
    }

    if (trimmedName && trimmedGst) {
      if (!isValidGst(trimmedGst)) {
        notify("Please enter a valid gst", "warning");
        setSaveLoading(false);
        setSaveAddLoading(false);
        return;
      }
      if (address || country || state || city || zipCode) {
        const response = await handleAddress(
          address,
          country?.value,
          state?.value,
          city,
          zipCode,
          localAddress,
          false
        );
        localResponse = response;
      }
      const formData = new FormData();
      formData.append("client_type", clientType);
      formData.append("name", trimmedName);
      formData.append("pan_number", tan);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("country_code", countryCode);
      formData.append("gst_number", trimmedGst);
      officeId && formData.append("office_location", officeId);
      if (localAddress || localResponse) {
        formData.append(
          "address",
          localResponse ? localResponse?.id : localAddress
        );
      }
      const response = await customAction(
        id ? `vendor/vendor/${id}/` : "vendor/vendor/",
        id ? "patch" : "post",
        formData,
        token,
        "Vendor",
        true
      );
      if (response) {
        typeof onCreated === "function" && onCreated(response?.data);
        // console.log(response);
        if (bank || branch || ifsc || accountName || accountNumber) {
          const bankResponse = handleAddBank(
            type,
            response?.data?.id,
            bankId,
            "vendor",
            false
          );
          // console.log(response, bankResponse);
        }
        if (type === "saveadd") {
          setClientType("COMPANY");
          setFName("");
          setGst("");
          setTan("");
          setEmail("");
          setSecondaryEmail("");

          setSelectedImage("");
          setPhone("");
          setCountryCode("in");
          setSameAsLocal(false);

          setAddress("");
          setCountry("");
          setState("");
          setCity("");
          setZipCode("");
          setLocalAddress("");

          setBank("");
          setBranch("");
          setIfsc("");
          setAccountName("");
          setAccountNumber("in");
        } else {
          onHide();
        }
        setId(null);
        fetchData();
      }
    } else {
      if (!trimmedName) notify("Name is required ", "warning");
      if (!trimmedGst) notify("GST number is required ", "warning");
    }
    setSaveLoading(false);
    setSaveAddLoading(false);
  };

  const handleAddProject = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    if (fName && client?.value && cost && currency?.value && hsn) {
      if (endDate && startDate) {
        const isLater = new Date(endDate) >= new Date(startDate);
        if (!isLater) {
          setSaveAddLoading(false);
          setSaveLoading(false);
          return notify("End date can't be before the start date");
        }
      }
      const formData = new FormData();
      formData.append("title", fName);
      formData.append("client", client?.value);
      startDate && formData.append("start_date", startDate);
      endDate && formData.append("end_date", endDate);
      formData.append("ongoing", ongoing);
      hsn && formData.append("hsn", hsn);
      description && formData.append("description", description);
      projectType?.value && formData.append("project_type", projectType?.value);
      currency?.value && formData.append("currency_id", currency?.value);
      cost && cost != "" && formData.append("cost", cost);
      paymentTerms?.value &&
        formData.append("payment_terms", paymentTerms?.value);
      formData.append("zoho_project_id", zohoProjectId || '');
      const response = await customAction(
        id ? `project/project/${id}/` : `project/project/`,
        id ? "patch" : "post",
        formData,
        token,
        "Team"
      );
      if (response) {
        if (!id) {
          navigate(`/projects/${response?.data?.id}`);
        } else {
          fetchData();
        }
        if (type === "saveadd") {
          setFName("");
          setClient("");
          setStartDate("");
          setOngoing(false);
          setEndDate("");
          setDescription("");
          setProjectType("");
          setCost("");
          setPaymentTerms("");
          setId(null);
        } else {
          onHide();
        }
      }
    } else {
      if (!fName) {
        notify("Project title is required", "warning");
      }
      if (!client?.value) {
        notify("Client  is required", "warning");
      }
      if (!ongoing && !endDate) {
        notify("Please add end date or set the project as ongoing", "warning");
      }
      // if (!zohoProjectId) {
      //   notify("Please add Zoho Project Id", "warning");
      // }
      if (!cost) {
        notify("Please add cost", "warning");
      }
      if (!currency?.value) {
        notify("Please select cost currency", "warning");
      }
      if (!hsn) {
        notify("Please add HSN/SAC value", "warning");
      }
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleAddMoM = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    if (fName && fName !== "" && startDate && startDate !== "") {
      const formData = new FormData();
      formData.append("title", fName);
      startDate && formData.append("date", startDate);
      formData.append("description", description);
      formData.append("project", project);
      formData.append("send_to_customer", send);
      formData.append("contacts", JSON.stringify(selectedContacts));
      const response = await customAction(
        id ? `project/mom/${id}/` : `project/mom/`,
        id ? "patch" : "post",
        formData,
        token,
        "MoM"
      );
      if (response) {
        if (type === "saveadd") {
          setFName("");
          setStartDate("");
          setDescription("");
          setId("");
        } else {
          onHide();
        }
        fetchData();
      }
    } else {
      if (!fName || fName === "") {
        notify("Title is required");
      } else if (!startDate || startDate === "") {
        notify("Date is required");
      }
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleAddMilestone = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setSaveLoading(true);
    }
    if (fName && fName !== "" && cost) {
      const formData = new FormData();
      formData.append("title", fName);
      status?.value && formData.append("status", status?.value);
      startDate && formData.append("start_date", startDate);
      endDate && formData.append("end_date", endDate);
      formData.append("description", description);
      formData.append("project", project);
      cost && cost != "" && formData.append("cost", cost);

      const response = await customAction(
        id ? `project/milestone/${id}/` : `project/milestone/`,
        id ? "patch" : "post",
        formData,
        token,
        "Team"
      );
      if (response) {
        if (type === "saveadd") {
          setFName("");
          setStatus({
            value: "ACTIVE",
            label: "ACTiVE",
          });
          setStartDate("");
          setEndDate("");
          setDescription("");
          setId("");
          setCost("");
        } else {
          onHide();
        }
        fetchData();
      }
    } else {
      if (!fName || fName === "") {
        notify("Milestone title is required");
      } else if (!cost) {
        notify("Please add cost", "warning");
      }
    }
    setSaveAddLoading(false);
    setSaveLoading(false);
  };

  const handleSubmit = (e, type) => {
    e.preventDefault();
    if (title === "Employee" || title === "Team Member") {
      handleAddEmployee(type);
    }
    if (title === "Client") {
      handleAddClient(type);
    }
    if (title === "New Bank") {
      handleAddBank(type, employeeId, id);
    }
    if (title === "Milestone") {
      handleAddMilestone(type);
    }
    if (title === "MoM") {
      if (send) {
        if (!fName || fName === "") {
          notify("Title is required");
          return;
        } else if (!startDate || startDate === "") {
          notify("Date is required");
          return;
        } else {
          setShow(true);
        }
      } else {
        handleAddMoM(type);
      }
    }
    if (title === "Project") {
      handleAddProject(type);
    }
    if (title === "Vendor") {
      handleAddVendor(type);
    }
    if (title === "Leave") {
      handleLeave(itemId, type);
    }
    if (title === "Bank Account") {
      handleAddBank(type, null, id, "office");
    }
    if (title === "New Office") {
      handleAddOffice(type);
    }
  };

  useEffect(() => {
    if (country?.value) {
      const newFilteredStateOptions = stateOptions?.filter(
        (item) => item?.country === country?.value
      );
      setFilteredStateOptions(newFilteredStateOptions);
      if (
        stateOptions?.length > 0 &&
        state?.value &&
        !newFilteredStateOptions.some((item) => item?.id === state.value)
      ) {
        setState("");
      }
    }
  }, [country]);

  useEffect(() => {
    if (permanentCountry?.value) {
      const newFilteredStateOptions = stateOptions?.filter(
        (item) => item?.country === permanentCountry?.value
      );
      setFilteredPermanentStateOptions(newFilteredStateOptions);
      if (
        stateOptions?.length > 0 &&
        permanentState?.value &&
        !newFilteredStateOptions.some(
          (item) => item?.id === permanentState?.value
        )
      ) {
        setPermanentState("");
      }
    }
  }, [permanentCountry]);

  if (!isOpen) return null;

  return (
    <div className="d-flex w-100">
      <div
        className={`d-flex justify-content-center w-100 ${
          layout === "centered" ? "align-items-center" : ""
        }`}
        style={
          layout === "centered"
            ? {
                position: "fixed",
                zIndex: 1055,
                inset: 0,
                padding: "16px",
                backgroundColor: "#00000073",
                overflowY: "auto",
              }
            : { position: "absolute", zIndex: "999", top: "50px", right: 0 }
        }
      >
        {layout !== "centered" && (
          <div
            className="d-none d-md-flex col-12 col-md-6 justify-content-center align-items-center mt-2 py-3 px-3 pe-0"
            style={{
              left: 0,
              backgroundColor: "#00000073",
            }}
          ></div>
        )}
        <div
          className={`${
            layout === "centered" ? "w-100 br-10" : "col-12 col-md-6"
          } border-0 focus-none bg-white ${
            layout === "centered" ? "mt-0 p-3" : "mt-0 mt-md-2 p-3 pe-0"
          }`}
          style={
            layout === "centered"
              ? {
                  width: "100%",
                  maxWidth: "980px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 32px)",
                }
              : { overflowY: "scroll", minHeight: "92vh", maxHeight: "92vh" }
          }
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="fs-20 fw-600">
              {id ? "Update" : title === "Leave" ? "Apply" : "Add"}{" "}
              {title === "Employee" || title === "Team Member"
                ? id
                  ? "Team Member"
                  : "New Team Member"
                : title}
            </div>
            <RiCloseCircleLine
              onClick={() => {
                onHide();
              }}
              className="text-primary c-p "
              size={25}
            />
          </div>
          <div className=" my-2" style={{ border: "2px solid #F3F4F4" }}></div>
          <form
            onSubmit={handleSubmit}
            className="d-flex flex-column p-2 gap-3"
          >
            {loading ? (
              <NoData loading={loading} height="60vh" color="text-primary" />
            ) : (
              <>
                {/* client type */}
                {(title === "Client" || title === "Vendor") && (
                  <div className="d-flex flex-column">
                    <p className="fs-16 fw-500 mb-2">
                      {title === "Vendor" ? "Vendor Type" : "Client Type"}
                    </p>
                    <div className="d-flex gap-3">
                      <div className="d-flex align-items-center gap-1">
                        <input
                          onChange={() => setClientType("COMPANY")}
                          type="radio"
                          name="clientType"
                          style={{ width: "16px", height: "16px" }}
                          checked={clientType === "COMPANY"}
                        />
                        <label
                          className="c-p"
                          onClick={() => setClientType("COMPANY")}
                        >
                          Company{" "}
                        </label>
                      </div>
                      <div className="d-flex align-items-center gap-1">
                        <input
                          onChange={() => setClientType("INDIVIDUAL")}
                          type="radio"
                          name="clientType"
                          style={{ width: "16px", height: "16px" }}
                          checked={clientType === "INDIVIDUAL"}
                        />
                        <label
                          className="c-p"
                          onClick={() => setClientType("INDIVIDUAL")}
                        >
                          Individual
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                {/* name and titles and status*/}
                {title === "Leave" &&
                  (user?.is_admin || user?.is_project_manager) && (
                    <div className="col-12">
                      <p className="fs-16 fw-500 mb-2">Employee</p>
                      <Select
                        value={employee}
                        onChange={(selectedOption) => {
                          setEmployee(selectedOption);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "100%",
                            border: "0px !important",
                            boxShadow: "0px !important",
                            backgroundColor: "#EFF6FA",
                            borderRadius: "5px",
                          }),
                        }}
                        className={`border-0 focus-none  ${employee === "" && "text-para"
                          }`}
                        options={employeeOptions}
                        placeholder=""
                      />
                    </div>
                  )}
                <div className="d-flex flex-column flex-md-row w-100">
                  {title !== "Bank Account" &&
                    title !== "New Bank" &&
                    title !== "Leave" &&
                    title !== "Leave Policy" && (
                      <div
                        className={` ${title === "Client" ||
                          title === "Project" ||
                          title === "MoM" ||
                          title === "New Office" ||
                          title === "Vendor"
                          ? "col-12"
                          : "col-12 col-md-6  pe-0 pe-md-2 "
                          } `}
                      >
                        <p className="fs-16 fw-500 mb-2">
                          {title === "Client"
                            ? clientType === "COMPANY"
                              ? "Company Name"
                              : "Name"
                            : title === "Project"
                              ? "Project Title"
                              : title === "New Office"
                                ? "Office Title"
                                : title === "Milestone"
                                  ? "Milestone Title"
                                  : title === "Vendor"
                                    ? "Name"
                                    : title === "MoM"
                                      ? "MoM Title"
                                      : "First Name"}
                          {title === "MoM" ? (
                            <span className="ms-2 fs-14">
                              (This will be used as subject line in case you
                              decide to send email)
                            </span>
                          ) : (
                            ""
                          )}
                        </p>
                        <input
                          value={fName}
                          onChange={(e) => setFName(e.target.value)}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          required
                          autoComplete="off"
                        />
                      </div>
                    )}

                  {title === "Employee" || title === "Team Member" && (
                    <div className="col-12 col-md-6">
                      <p className="fs-16 fw-500 mb-2">Last Name</p>
                      <input
                        value={lName}
                        onChange={(e) => setLName(e.target.value)}
                        type="text"
                        className="w-100 rounded custom-input px-3 py-2"
                        required
                        autoComplete="off"
                      />
                    </div>
                  )}
                  {title === "Milestone" && (
                    <div className="col-12 col-md-6 ">
                      <p className="fs-16 fw-500 mb-2">Status</p>
                      <Select
                        value={status}
                        onChange={(selectedOption) => {
                          setStatus(selectedOption);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "100%",
                            border: "0px !important",
                            boxShadow: "0px !important",
                            backgroundColor: "#EFF6FA",
                            borderRadius: "5px",
                          }),
                        }}
                        className={`border-0 focus-none  ${status === "" && "text-para"
                          }`}
                        options={statusOptions?.map((item) => ({
                          value: item,
                          label: item,
                        }))}
                        placeholder=""
                      />
                    </div>
                  )}

                  {title === "Leave" && (
                    <div className="d-flex flex-column flex-md-row col-12 ">
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="fs-16 fw-500 mb-2">Leave Type</p>
                        <Select
                          value={leaveType}
                          onChange={(selectedOption) => {
                            setLeaveType(selectedOption);
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              width: "100%",
                              border: "0px !important",
                              boxShadow: "0px !important",
                              backgroundColor: "#EFF6FA",
                              borderRadius: "5px",
                            }),
                          }}
                          className={`border-0 focus-none  ${leaveType === "" && "text-para"
                            }`}
                          options={leaveTypeOptions}
                          placeholder=""
                        />
                        {leaveType?.value && (
                          <p className="mt-1">
                            Leave type is{" "}
                            {leaveType?.leave_type_details?.is_paid
                              ? "Paid"
                              : "Unpaid"}
                          </p>
                        )}
                      </div>
                      <div className="col-12 col-md-6">
                        <p className="fs-16 fw-500 mb-2">Document (Optional)</p>
                        <div
                          onClick={() => fileInputRef.current.click()}
                          className=" d-flex align-items-center justify-content-center text-tertiary-dark bg-light p-2 w-100  c-p "
                        >
                          <RiImage2Line size={18} className="me-2" /> Upload
                          Document Here
                        </div>
                        <div className="fs-14">
                          {typeof selectedImage === "string"
                            ? truncateString(
                              selectedImage?.split("/")?.pop(),
                              20
                            )
                            : truncateString(selectedImage?.name, 20)}
                        </div>
                        <input
                          ref={fileInputRef}
                          type="file"
                          onChange={handleFileChange}
                          className="d-none"
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* gst number and pan and tan number */}
                {(title === "Vendor" || title === "New Office") && (
                  <div className="d-flex flex-column flex-md-row align-items-center">
                    <div
                      className={` ${title === "New Office"
                        ? "col-12"
                        : "col-12 col-md-6  pe-0 pe-md-2 "
                        }`}
                    >
                      <p className="fs-16 fw-500 mb-2">GST Number</p>
                      <input
                        value={gst}
                        onChange={(e) => setGst(e.target.value)}
                        type="text"
                        className="w-100 rounded custom-input px-3 py-2"
                        placeholder=""
                        required
                        autoComplete="off"
                      />
                    </div>
                    {(title === "Client" || title === "Vendor") && (
                      <div className="col-12 col-md-6">
                        <p className="fs-16 fw-500 mb-2">
                          {title === "Vendor" ? "PAN Number" : "TAN Number"}
                        </p>
                        <input
                          value={tan}
                          onChange={(e) => setTan(e.target.value)}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          autoComplete="off"
                        />
                      </div>
                    )}
                  </div>
                )}
                {/* client and owner and start/end date */}
                {(title === "Project" ||
                  title === "Milestone" ||
                  title === "MoM" ||
                  title === "Leave") && (
                    <>
                      {title === "Project" && (
                        <>
                          <div className="d-flex flex-column flex-md-row w-100">
                            <div className="col-12">
                              <p className="fs-16 fw-500 mb-2">Client</p>
                              <Select
                                value={client}
                                onChange={(selectedOption) => {
                                  setClient(selectedOption);
                                }}
                                styles={{
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "100%",
                                    border: "0px !important",
                                    boxShadow: "0px !important",
                                    backgroundColor: "#EFF6FA",
                                    borderRadius: "5px",
                                  }),
                                }}
                                className={`border-0 focus-none  ${client === "" && "text-para"
                                  }`}
                                options={clientOptions?.map((item) => ({
                                  value: item?.id,
                                  label: item?.name,
                                }))}
                                placeholder=""
                              />
                            </div>
                          </div>
                          <span className="d-flex align-items-center gap-2">
                            {ongoing ? (
                              <MdCheckBox
                                className=" c-p  text-primary"
                                onClick={() => setOngoing(false)}
                                size={20}
                              />
                            ) : (
                              <MdCheckBoxOutlineBlank
                                className=" c-p  text-tertiary-dark"
                                onClick={() => {
                                  if (projectType?.value === "FIXED BUDGET") {
                                    notify(
                                      "Fixed budget projects can't be set to ongoing.",
                                      "warning"
                                    );
                                  } else {
                                    setOngoing(true);
                                    title === "Project" && setEndDate("");
                                  }
                                }}
                                size={20}
                              />
                            )}
                            <span
                              onClick={() => {
                                if (
                                  projectType?.value === "FIXED BUDGET" &&
                                  !ongoing
                                ) {
                                  notify(
                                    "Fixed budget projects can't be set to ongoing.",
                                    "warning"
                                  );
                                } else {
                                  setOngoing(!ongoing);
                                }
                              }}
                              className="c-p fs-14 fw-400 text-tertiary-dark"
                            >
                              Ongoing Project
                            </span>
                          </span>
                          <div className="col-12 col-md-6">
                            <p className="fs-16 fw-500 mb-2">
                              {"Zoho Project ID"}
                            </p>
                            <input
                              value={zohoProjectId}
                              onChange={(e) => setZohoProjectId(e.target.value)}
                              type="text"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        </>
                      )}

                      <div className="d-flex flex-column flex-md-row w-100">
                        <div
                          className={` ${title === "MoM" ? "col-12" : "col-12 col-md-6"
                            }  pe-0 pe-md-2`}
                        >
                          <p className="fs-16 fw-500 mb-2">
                            {title === "Leave"
                              ? "From"
                              : title === "MoM"
                                ? "Meeting Date "
                                : "Start Date"}
                          </p>
                          <input
                            value={startDate}
                            onChange={(e) => {
                              if (title === "Leave") {
                                const today = new Date();
                                const selectedDate = new Date(e.target.value);
                                const timeDifference = selectedDate - today;
                                const dayDifference =
                                  timeDifference / (1000 * 3600 * 24);
                                const requiredNoticeDays =
                                  leaveType?.minimum_notice_days || 0;
                                if (
                                  dayDifference < requiredNoticeDays &&
                                  requiredNoticeDays > 0
                                ) {
                                  setErrors({
                                    startDate: `The leave start date is less than ${requiredNoticeDays} days from today. Please plan accordingly.`,
                                  });
                                } else {
                                  setErrors({
                                    startDate: "",
                                  });
                                }
                              }
                              setStartDate(e.target.value);
                            }}
                            type="date"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                            max={
                              title === "MoM"
                                ? new Date().toISOString().split("T")[0]
                                : null
                            }
                          />
                          {errors?.startDate && (
                            <p className="fs-14">{errors?.startDate}</p>
                          )}
                        </div>
                        {title !== "MoM" && (
                          <div className="col-12 col-md-6 ">
                            <p className="fs-16 fw-500 mb-2">
                              {title === "Leave" ? (
                                <>Till</>
                              ) : (
                                <>
                                  {title === "Milestone" && "Expected"} End Date
                                </>
                              )}
                            </p>
                            <input
                              value={endDate}
                              disabled={ongoing}
                              onChange={(e) => setEndDate(e.target.value)}
                              type={ongoing ? "text" : "date"}
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        )}
                      </div>

                      <div className="w-100" style={{ zIndex: 0 }}>
                        <p className="fs-16 fw-500 mb-2">
                          {title === "MoM" ? "MoM Details" : "Description"}
                          {title === "MoM" ? (
                            <span className="ms-2 fs-14">
                              (The content will be used as the body in case you
                              decide to send email)
                            </span>
                          ) : (
                            ""
                          )}
                        </p>
                        <CKEditor
                          editor={ClassicEditor}
                          data={description}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setDescription(data);
                          }}
                          config={
                            title === "MoM"
                              ? ckEditorImageConfiguration
                              : ckEditorConfiguration
                          }
                          className="br-10"
                        />
                      </div>

                      {title === "MoM" && (
                        <span className="d-flex align-items-center gap-2">
                          {send ? (
                            <MdCheckBox
                              className=" c-p  text-primary"
                              onClick={() => setSend(false)}
                              size={20}
                            />
                          ) : (
                            <MdCheckBoxOutlineBlank
                              className="c-p text-tertiary-dark"
                              onClick={() => {
                                setSend(true);
                              }}
                              size={20}
                            />
                          )}
                          <span
                            onClick={() => setSend(!send)}
                            className="c-p fs-15 fw-400 text-tertiary-dark"
                          >
                            Send to customer
                          </span>
                        </span>
                      )}
                      {(title === "Project" || title === "Milestone") && (
                        <>
                          <div className="d-flex flex-column flex-md-row align-items-center">
                            {title === "Project" && (
                              <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                                <p className="fs-16 fw-500 mb-2">Project Type</p>
                                <Select
                                  value={projectType}
                                  onChange={(selectedOption) => {
                                    setProjectType(selectedOption);
                                  }}
                                  styles={{
                                    control: (baseStyles, state) => ({
                                      ...baseStyles,
                                      width: "100%",
                                      border: "0px !important",
                                      boxShadow: "0px !important",
                                      backgroundColor: "#EFF6FA",
                                      borderRadius: "5px",
                                    }),
                                  }}
                                  className={`border-0 focus-none  ${projectType === "" && "text-para"
                                    }`}
                                  options={projectTypeOptions?.map((item) => ({
                                    value: item,
                                    label: item,
                                  }))}
                                  placeholder=""
                                  menuPlacement="top"
                                />
                              </div>
                            )}
                            <div className="col-12 col-md-6 pe-0">
                              <p className="fs-16 fw-500 mb-2">
                                Cost{" "}
                                {title === "Milestone" && `(${currencySymbol})`}
                              </p>
                              <div className="d-flex align-items-center">
                                {title === "Project" && (
                                  <div className="col-3">
                                    <Select
                                      value={currency}
                                      onChange={(selectedOption) => {
                                        setCurrency(selectedOption);
                                      }}
                                      styles={{
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          width: "100%",
                                          border: "0px !important",
                                          boxShadow: "0px !important",
                                          backgroundColor: "#EFF6FA",
                                          borderRadius: "5px",
                                          padding: "0px !important",
                                        }),
                                        valueContainer: (baseStyles, state) => ({
                                          ...baseStyles,
                                          padding: "2px !important",
                                        }),
                                      }}
                                      className={`border-0 focus-none  ${currency === "" && "text-para"
                                        }`}
                                      options={currencyOptions?.map((item) => ({
                                        value: item?.id,
                                        label: item?.code,
                                      }))}
                                      // components={{ SingleValue }}
                                      placeholder=""
                                      menuPlacement="top"
                                    />
                                  </div>
                                )}
                                <div className="col-9 ps-1">
                                  <input
                                    value={cost}
                                    onChange={(e) => setCost(e.target.value)}
                                    type="text"
                                    min={0}
                                    className="w-100 rounded custom-input px-3 py-2"
                                    placeholder=""
                                    required
                                    autoComplete="off"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {title === "Project" && (
                            <div className="d-flex flex-column flex-md-row align-items-center">
                              <div className="col-12 col-md-6 d-flex flex-column">
                                <p className="fs-16 fw-500 mb-2">Payment Terms</p>
                                <Select
                                  value={paymentTerms}
                                  onChange={(selectedOption) => {
                                    setPaymentTerms(selectedOption);
                                  }}
                                  styles={{
                                    control: (baseStyles, state) => ({
                                      ...baseStyles,
                                      width: "100%",
                                      border: "0px !important",
                                      boxShadow: "0px !important",
                                      backgroundColor: "#EFF6FA",
                                      borderRadius: "5px",
                                    }),
                                  }}
                                  className={`border-0 focus-none  ${paymentTerms === "" && "text-para"
                                    }`}
                                  options={paymentTermOptions?.map((item) => ({
                                    value: item?.value,
                                    label: item?.label,
                                  }))}
                                  placeholder=""
                                  menuPlacement="top"
                                />
                              </div>
                              <div className="ps-1 w-100">
                                <p className="fs-16 fw-500 mb-2">HSN/SAC</p>
                                <input
                                  value={hsn}
                                  onChange={(e) => setHsn(e.target.value)}
                                  type="number"
                                  className="w-100 rounded custom-input px-3 py-2"
                                  placeholder=""
                                  required
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}

                {/* role and team */}
                {title === "Employee" || title === "Team Member" && (
                  <div className="d-flex flex-column flex-md-row w-100">
                    <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                      <p className="fs-16 fw-500 mb-2">Role</p>
                      <Select
                        value={role}
                        onChange={(selectedOption) => {
                          setRole(selectedOption);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "100%",
                            border: "0px !important",
                            boxShadow: "0px !important",
                            backgroundColor: "#EFF6FA",
                            borderRadius: "5px",
                          }),
                        }}
                        className={`border-0 focus-none `}
                        options={roleOptions?.map((item) => ({
                          value: item?.id,
                          label: item?.name,
                        }))}
                        placeholder=""
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <p className="fs-16 fw-500 mb-0">Team</p>
                        <Button
                          className="m-0 p-0 text-decoration-none bg-transparent text-primary fw-500"
                          variant="link"
                          onClick={() => setShowTeam(true)}
                        >
                          Create a new team?
                        </Button>
                      </div>
                      <Select
                        value={team}
                        onChange={(selectedOption) => {
                          setTeam(selectedOption);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "100%",
                            border: "0px !important",
                            boxShadow: "0px !important",
                            backgroundColor: "#EFF6FA",
                            borderRadius: "5px",
                          }),
                        }}
                        className={`border-0 focus-none  ${team === "" && "text-para"
                          }`}
                        options={teamOptions?.map((item) => ({
                          value: item?.id,
                          label: item?.name,
                        }))}
                        placeholder=""
                      />
                    </div>
                  </div>
                )}
                {/* website url and company logo */}
                {title === "Client" && (
                  <div className="d-flex flex-column flex-md-row ">
                    <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                      <p className="fs-16 fw-500 mb-2">Website URL</p>
                      <input
                        value={websiteUrl}
                        onChange={(e) => setWebsiteUrl(e.target.value)}
                        type="text"
                        className="w-100 rounded custom-input px-3 py-2"
                        placeholder=""
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <p className="fs-16 fw-500 mb-2">Company Logo</p>
                      <div
                        onClick={() => fileInputRef.current.click()}
                        className=" d-flex align-items-center justify-content-center text-tertiary-dark bg-light p-2 w-100  c-p "
                      >
                        <RiImage2Line size={18} className="me-2" /> Upload Logo
                        Here
                      </div>
                      {selectedImage && (
                        <img
                          src={
                            typeof selectedImage === "string"
                              ? selectedImage
                              : URL.createObjectURL(selectedImage)
                          }
                          alt=""
                          className="mt-1 br-50"
                          style={{
                            height: "60px",
                            width: "60px",
                          }}
                        />
                      )}
                      <div className="fs-14">
                        {typeof selectedImage === "string"
                          ? truncateString(selectedImage?.split("/")?.pop(), 20)
                          : truncateString(selectedImage?.name, 20)}
                      </div>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="d-none"
                      />
                    </div>
                  </div>
                )}
                {/* email and phone number */}
                {(title === "Employee" || title === "Vendor" || title === "Team Member") && (
                  <div className="d-flex flex-column flex-md-row w-100">
                    <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                      <p className="mb-2">
                        <span className="fs-16 fw-500">Email Address</span>
                      </p>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        className="w-100 rounded custom-input px-3 py-2"
                        placeholder=""
                        required
                        autoComplete="off"
                      />
                    </div>

                    <div className="col-12 col-md-6 ">
                      <p className="fs-16 fw-500 mb-2">Phone Number</p>
                      {phone && (
                        <ContactInput
                          phone={phone}
                          setPhone={setPhone}
                          countryCode={countryCode}
                          setCountryCode={setCountryCode}
                        />
                      )}
                      {!phone && (
                        <ContactInput
                          phone={phone}
                          setPhone={setPhone}
                          countryCode={countryCode}
                          setCountryCode={setCountryCode}
                        />
                      )}
                    </div>
                  </div>
                )}
                {/* cost per hour and dob */}
                {title === "Employee" || title === "Team Member" && (
                  <>
                    <div className="d-flex flex-column flex-md-row w-100">
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="mb-2">
                          <span className="fs-16 fw-500">Cost Per Hour</span>
                          <span>(Optional)</span>
                        </p>
                        <div className="d-flex align-items-center ">
                          <input
                            value={costPerHour}
                            onChange={(e) => setCostPerHour(e.target.value)}
                            type="text"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 ">
                        <p className="fs-16 fw-500 mb-2">Date Of Birth</p>
                        <input
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                          type="date"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          max={
                            new Date(
                              new Date().setDate(new Date().getDate() - 1)
                            )
                              .toISOString()
                              .split("T")[0]
                          }
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row w-100">
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="fs-16 fw-500 mb-2">Date Of Joining</p>
                        <input
                          value={doj}
                          onChange={(e) => setDoj(e.target.value)}
                          type="date"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="mb-2">
                          <span className="fs-16 fw-500">
                            Secondary Email Address
                          </span>
                        </p>
                        <input
                          value={secondaryEmail}
                          onChange={(e) => setSecondaryEmail(e.target.value)}
                          type="email"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    {user?.is_admin && (
                      <div className="d-flex flex-column flex-md-row w-100">
                        <div className="col-12 col-md-6 pe-md-2 ">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <p className="fs-16 fw-500 mb-0">Status</p>
                          </div>
                          <Select
                            value={status}
                            onChange={(selectedOption) => {
                              setStatus(selectedOption);
                            }}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                width: "100%",
                                border: "0px !important",
                                boxShadow: "0px !important",
                                backgroundColor: "#EFF6FA",
                                borderRadius: "5px",
                              }),
                            }}
                            className={`border-0 focus-none  ${status === "" && "text-para"
                              }`}
                            options={[
                              { value: "ACTIVE", label: "ACTIVE" },
                              { value: "LEFT", label: "LEFT" },
                            ]?.map((item) => ({
                              value: item?.value,
                              label: item?.label,
                            }))}
                            placeholder=""
                          />
                        </div>
                        {user?.is_admin && status?.value === "LEFT" && (
                          <div className="col-12 col-md-6 pe-0 pe-md-2">
                            <p className="fs-16 fw-500 mb-2">Date Of Leaving</p>
                            <input
                              value={dol}
                              onChange={(e) => setDol(e.target.value)}
                              type="date"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {user?.is_admin && status?.value === "LEFT" && (
                      <>
                        <div className="d-flex flex-column gap-2">
                          <span>Reason for leaving</span>
                          <div className="fw-600">
                            <textarea
                              value={reasonForLeaving}
                              onChange={(e) =>
                                setReasonForLeaving(e.target.value)
                              }
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder="Enter reason for leaving"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* emergency contact details */}
                {title === "Employee" || title === "Team Member" && (
                  <>
                    <div className="fs-20 fw-600">
                      Emergency Contact Details
                    </div>
                    <div>
                      <p className="fs-16 fw-500 mb-2">Full Name</p>
                      <div className="d-flex align-items-center">
                        <select
                          value={emergencySalutation}
                          onChange={(e) =>
                            setEmergencySalutation(e.target.value)
                          }
                          className="d-none custom-input px-3 py-2 rounded"
                          required
                        >
                          {salutationOptions?.map((sal, index) => (
                            <option key={index} value={sal}>
                              {sal}
                            </option>
                          ))}
                        </select>
                        <input
                          value={emergencyName}
                          onChange={(e) => setEmergencyName(e.target.value)}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-center">
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="fs-16 fw-500 mb-2">Phone Number</p>
                        {emergencyPhone && (
                          <ContactInput
                            phone={emergencyPhone}
                            countryCode={emergencyCountryCode}
                            setPhone={setEmergencyPhone}
                            setCountryCode={setEmergencyCountryCode}
                          />
                        )}
                        {!emergencyPhone && (
                          <ContactInput
                            phone={emergencyPhone}
                            countryCode={emergencyCountryCode}
                            setPhone={setEmergencyPhone}
                            setCountryCode={setEmergencyCountryCode}
                          />
                        )}
                      </div>
                      <div className="col-12 col-md-6">
                        <p className="fs-16 fw-500 mb-2">Relationship</p>
                        <Select
                          value={emergencyRelation}
                          onChange={(selectedOption) => {
                            setEmergencyRelation(selectedOption);
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              width: "100%",
                              border: "0px !important",
                              boxShadow: "0px !important",
                              backgroundColor: "#EFF6FA",
                              borderRadius: "5px",
                            }),
                          }}
                          className={`border-0 focus-none  ${emergencyRelation === "" && "text-para"
                            }`}
                          options={relationOptions?.map((item) => ({
                            value: item,
                            label: item,
                          }))}
                          placeholder=""
                        />
                      </div>
                    </div>
                  </>
                )}
                {/* company address and local address and address */}
                {(title === "Employee" ||
                  title === "Client" ||
                  title === "Team Member" ||
                  title === "Vendor" ||
                  title === "New Office") && (
                    <>
                      <div className="fs-20 fw-600">
                        {title === "Client"
                          ? "Company Address"
                          : title === "Employee" || title === "Team Member"
                            ? "Local Address"
                            : "Address"}
                      </div>
                      <div>
                        <p className="fs-16 fw-500 mb-2">Address</p>
                        <input
                          value={address}
                          onChange={(e) => {
                            if (sameAsLocal) {
                              setPermanentAddress(e.target.value);
                            }
                            setAddress(e.target.value);
                          }}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                      <div className="d-flex flex-column flex-md-row align-items-center">
                        <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                          <p className="fs-16 fw-500 mb-2">Country</p>
                          <Select
                            value={country}
                            onChange={(selectedOption) => {
                              if (sameAsLocal) {
                                setPermanentCountry(selectedOption);
                              }
                              setCountry(selectedOption);
                            }}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                width: "100%",
                                border: "0px !important",
                                boxShadow: "0px !important",
                                backgroundColor: "#EFF6FA",
                                borderRadius: "5px",
                              }),
                            }}
                            className={`border-0 focus-none  ${country === "" && "text-para"
                              }`}
                            options={countryOptions?.map((item) => ({
                              value: item?.id,
                              label: item?.name,
                            }))}
                            placeholder=""
                            menuPlacement="top"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <p className="fs-16 fw-500 mb-2">State</p>
                          <Select
                            value={state}
                            onChange={(selectedOption) => {
                              if (sameAsLocal) {
                                setPermanentState(selectedOption);
                              }
                              setState(selectedOption);
                            }}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                width: "100%",
                                border: "0px !important",
                                boxShadow: "0px !important",
                                backgroundColor: "#EFF6FA",
                                borderRadius: "5px",
                              }),
                            }}
                            className={`border-0 focus-none  ${state === "" && "text-para"
                              }`}
                            options={filteredStateOptions?.map((item) => ({
                              value: item?.id,
                              label: item?.name,
                            }))}
                            placeholder=""
                            menuPlacement="top"
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-md-row align-items-center">
                        <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                          <p className="fs-16 fw-500 mb-2">City</p>
                          <input
                            value={city}
                            onChange={(e) => {
                              if (sameAsLocal) {
                                setPermanentCity(e.target.value);
                              }
                              setCity(e.target.value);
                            }}
                            type="text"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <p className="fs-16 fw-500 mb-2">Zip Code</p>
                          <input
                            value={zipCode}
                            onChange={(e) => {
                              if (sameAsLocal) {
                                setPermanentZipCode(e.target.value);
                              }
                              setZipCode(e.target.value);
                            }}
                            type="number"
                            onKeyDown={preventInvalidNumberInput}
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      {/* billing address and permanent address */}
                      {(title === "Employee" || title === "Client" || title === "Team Member") && (
                        <>
                          <div className="d-flex align-items-center gap-2">
                            <span className="fs-20 fw-600">
                              {title === "Client"
                                ? "Billing Address"
                                : "Permanent Address"}
                            </span>
                            <span className="d-flex align-items-center">
                              {sameAsLocal ? (
                                <MdCheckBox
                                  className=" c-p  text-tertiary-dark"
                                  onClick={() => {
                                    if (sameAsLocal) {
                                      setPermanentAddress("");
                                      setPermanentCountry("");
                                      setPermanentState("");
                                      setPermanentCity("");
                                      setPermanentZipCode("");
                                      setSameAsLocal(false);
                                    }
                                  }}
                                  size={20}
                                />
                              ) : (
                                <MdCheckBoxOutlineBlank
                                  className="c-p text-tertiary-dark"
                                  onClick={handleSetSameAsLocal}
                                  size={20}
                                />
                              )}
                              <span className="fs-14 fw-400 text-tertiary-dark">
                                {title === "Client"
                                  ? "Same as address"
                                  : "Same as local Address"}
                              </span>
                            </span>
                          </div>
                          <div>
                            <p className="fs-16 fw-500 mb-2">Address</p>
                            <input
                              disabled={sameAsLocal}
                              value={permanentAddress}
                              onChange={(e) =>
                                setPermanentAddress(e.target.value)
                              }
                              type="text"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                          <div className="d-flex flex-column flex-md-row align-items-center">
                            <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                              <p className="fs-16 fw-500 mb-2">Country</p>
                              <Select
                                disabled={sameAsLocal}
                                value={permanentCountry}
                                onChange={(selectedOption) => {
                                  setPermanentCountry(selectedOption);
                                }}
                                styles={{
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "100%",
                                    border: "0px !important",
                                    boxShadow: "0px !important",
                                    backgroundColor: "#EFF6FA",
                                    borderRadius: "5px",
                                  }),
                                }}
                                className={`border-0 focus-none  ${permanentCountry === "" && "text-para"
                                  }`}
                                options={countryOptions?.map((item) => ({
                                  value: item?.id,
                                  label: item?.name,
                                }))}
                                placeholder=""
                                menuPlacement="top"
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <p className="fs-16 fw-500 mb-2">State</p>
                              <Select
                                disabled={sameAsLocal}
                                value={permanentState}
                                onChange={(selectedOption) => {
                                  setPermanentState(selectedOption);
                                }}
                                styles={{
                                  control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "100%",
                                    border: "0px !important",
                                    boxShadow: "0px !important",
                                    backgroundColor: "#EFF6FA",
                                    borderRadius: "5px",
                                  }),
                                }}
                                className={`border-0 focus-none  ${state === "" && "text-para"
                                  }`}
                                options={filteredPermanentStateOptions?.map(
                                  (item) => ({
                                    value: item?.id,
                                    label: item?.name,
                                  })
                                )}
                                placeholder=""
                                menuPlacement="top"
                              />
                            </div>
                          </div>
                          <div className="d-flex flex-column flex-md-row align-items-center">
                            <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                              <p className="fs-16 fw-500 mb-2">City</p>
                              <input
                                disabled={sameAsLocal}
                                value={permanentCity}
                                onChange={(e) => setPermanentCity(e.target.value)}
                                type="text"
                                className="w-100 rounded custom-input px-3 py-2"
                                placeholder=""
                                required
                                autoComplete="off"
                              />
                            </div>
                            <div className="col-12 col-md-6">
                              <p className="fs-16 fw-500 mb-2">Zip Code</p>
                              <input
                                disabled={sameAsLocal}
                                value={permanentZipCode}
                                onChange={(e) =>
                                  setPermanentZipCode(e.target.value)
                                }
                                type="number"
                                onKeyDown={preventInvalidNumberInput}
                                className="w-100 rounded custom-input px-3 py-2"
                                placeholder=""
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                {/* upload profile picture */}
                {title === "Employee" || title === "Team Member" && (
                  <>
                    <div className="fs-20 fw-600">Upload Profile Picture</div>
                    <div>
                      <div className="">
                        <p className="fs-16 fw-500 mb-2">Profile Picture</p>
                        <div
                          onClick={() => fileInputRef.current.click()}
                          className="d-flex align-items-center justify-content-center text-tertiary-dark bg-light p-2 w-100  c-p "
                        >
                          <RiImage2Line size={18} /> Upload Image Here
                        </div>
                        {selectedImage && (
                          <img
                            src={
                              typeof selectedImage === "string"
                                ? selectedImage
                                : URL.createObjectURL(selectedImage)
                            }
                            alt=""
                            className="pt-1 br-50"
                            style={{
                              height: "60px",
                              width: "60px",
                            }}
                          />
                        )}
                        <div className="fs-14">
                          {typeof selectedImage === "string"
                            ? truncateString(
                              selectedImage?.split("/")?.pop(),
                              20
                            )
                            : truncateString(selectedImage?.name, 20)}
                        </div>
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*"
                          onChange={handleFileChange}
                          className="d-none"
                        />
                      </div>
                    </div>
                  </>
                )}
                {/* bank details */}
                {(title === "Employee" ||
                  title === "Team Member" ||
                  title === "Vendor" ||
                  title === "Bank Account" ||
                  title === "New Bank") && (
                    <>
                      <div className="fs-20 fw-600">Add Bank Details</div>
                      <div>
                        <p className="fs-16 fw-500 mb-2">Bank</p>
                        <input
                          value={bank}
                          onChange={(e) => setBank(e.target.value)}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>

                      <div className="d-flex flex-column flex-md-row align-items-center">
                        <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                          <p className="fs-16 fw-500 mb-2">Branch</p>
                          <input
                            value={branch}
                            onChange={(e) => setBranch(e.target.value)}
                            type="text"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <p className="fs-16 fw-500 mb-2">IFSC Code</p>
                          <input
                            value={ifsc}
                            onChange={(e) => setIfsc(e.target.value)}
                            type="text"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-md-row align-items-center">
                        <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                          <p className="fs-16 fw-500 mb-2">Account Holder Name</p>
                          <input
                            value={accountName}
                            onChange={(e) => setAccountName(e.target.value)}
                            type="text"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <p className="fs-16 fw-500 mb-2">Account Number</p>
                          <input
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                            type="number"
                            onKeyDown={preventInvalidNumberInput}
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <p className="fs-16 fw-500 mb-2">SWIFT/BIC</p>
                        <input
                          value={swift}
                          onChange={(e) => setSwift(e.target.value)}
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                    </>
                  )}
                {/* primary contact */}
                {title === "Client" && (
                  <>
                    <div className="fs-20 fw-600">Primary Contact</div>
                    <div className="d-flex flex-column flex-md-row align-items-center">
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="fs-16 fw-500 mb-2">Full Name</p>
                        <div className="d-flex align-items-center">
                          <div className="col-2">
                            <select
                              className="bg-light w-100 border-0 text-tertiary-dark fs-15"
                              id="prefixSelect"
                              style={{
                                height: "40px",
                                borderRadius: "5px 0px 0px 5px",
                              }}
                              value={primaryNamePrefix}
                              onChange={(e) =>
                                setPrimaryNamePrefix(e.target.value)
                              }
                            >
                              {prefixOptions?.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="ps-1 col-12">
                            <input
                              value={primaryName}
                              onChange={(e) => setPrimaryName(e.target.value)}
                              type="text"
                              className="col-10 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <p className="fs-16 fw-500 mb-2">Designation</p>
                        <input
                          value={primaryDesignation}
                          onChange={(e) =>
                            setPrimaryDesignation(e.target.value)
                          }
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="d-flex flex-column flex-md-row align-items-center">
                      <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                        <p className="fs-16 fw-500 mb-2">Phone Number</p>
                        {primaryCountryCode && primaryPhone && (
                          <ContactInput
                            phone={primaryPhone}
                            countryCode={primaryCountryCode}
                            setPhone={setPrimaryPhone}
                            setCountryCode={setPrimaryCountryCode}
                          />
                        )}
                        {!primaryPhone && (
                          <ContactInput
                            phone={primaryPhone}
                            countryCode={primaryCountryCode}
                            setPhone={setPrimaryPhone}
                            setCountryCode={setPrimaryCountryCode}
                          />
                        )}
                      </div>
                      <div className="col-12 col-md-6">
                        <p className="fs-16 fw-500 mb-2">Email Address</p>
                        <input
                          value={primaryEmail}
                          onChange={(e) => setPrimaryEmail(e.target.value)}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    {otherContacts?.map((oc, ocIndex) => (
                      <div key={ocIndex}>
                        <div className="d-flex align-items-center gap-2">
                          <div className="fs-20 fw-600">Other Contacts</div>
                          <Button
                            className="mx-0 px-0 text-decoration-none bg-transparent text-primary fw-500"
                            variant="link"
                            onClick={() => {
                              setShowDelete(true);
                              setDeleteItem(ocIndex);
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                        <div className="d-flex flex-column flex-md-row align-items-center">
                          <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                            <p className="fs-16 fw-500 mb-2">Full Name</p>
                            <div className="d-flex align-items-center">
                              <div className="col-2">
                                <select
                                  className="bg-light border-0 text-tertiary-dark"
                                  id="prefixSelect"
                                  style={{
                                    height: "40px",
                                    borderRadius: "5px 0px 0px 5px",
                                  }}
                                  value={oc?.prefix}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    const updatedItem = {
                                      ...oc,
                                      prefix: newValue,
                                    };
                                    const updatedItems = [...otherContacts];
                                    updatedItems[ocIndex] = updatedItem;
                                    setOtherContacts(updatedItems);
                                  }}
                                >
                                  {prefixOptions?.map((item, index) => (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-12">
                                <input
                                  value={oc?.name}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    const updatedItem = {
                                      ...oc,
                                      name: newValue,
                                    };
                                    const updatedItems = [...otherContacts];
                                    updatedItems[ocIndex] = updatedItem;
                                    setOtherContacts(updatedItems);
                                  }}
                                  type="text"
                                  className="col-10 rounded custom-input px-3 py-2"
                                  placeholder=""
                                  required
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="fs-16 fw-500 mb-2">Designation</p>
                            <input
                              value={oc?.designation}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                const updatedItem = {
                                  ...oc,
                                  designation: newValue,
                                };
                                const updatedItems = [...otherContacts];
                                updatedItems[ocIndex] = updatedItem;
                                setOtherContacts(updatedItems);
                              }}
                              type="text"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        <div className="d-flex flex-column flex-md-row align-items-center">
                          <div className="col-12 col-md-6  pe-0 pe-md-2 ">
                            <p className="fs-16 fw-500 mb-2">Phone Number</p>
                            <PhoneInput
                              className={"border-0 focus-none"}
                              country={oc?.countryCode}
                              enableSearch={true}
                              value={oc?.phone}
                              inputStyle={{
                                width: "100%",
                                height: "42px",
                                border: "0px solid #DFE5E0",
                                outline: "none",
                                borderRadius: "8px",
                                backgroundColor: "#EFF6FA",
                              }}
                              onChange={(ph, country) => {
                                const newValue = "+" + ph;
                                const newCountryValue = country.countryCode;
                                const updatedItem = {
                                  ...oc,
                                  phone: newValue,
                                  countryCode: newCountryValue,
                                };
                                const updatedItems = [...otherContacts];
                                updatedItems[ocIndex] = updatedItem;
                                setOtherContacts(updatedItems);
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="fs-16 fw-500 mb-2">Email Address</p>
                            <input
                              value={oc?.email}
                              onChange={(e) => {
                                const newValue = e.target.value;
                                const updatedItem = {
                                  ...oc,
                                  email: newValue,
                                };
                                const updatedItems = [...otherContacts];
                                updatedItems[ocIndex] = updatedItem;
                                setOtherContacts(updatedItems);
                              }}
                              type="text"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="m-0 p-0">
                      <Button
                        onClick={handleAddOtherContact}
                        className="mx-0 px-0 text-decoration-none bg-transparent text-primary fw-500"
                        variant="link"
                      >
                        Add More Contacts
                      </Button>
                    </div>
                  </>
                )}
                {/* invoice settings */}
                {title === "Client" && (
                  <>
                    <div className="fs-20 fw-600">Invoice Setting</div>
                    <div className="d-flex flex-column flex-md-row align-items-center">
                      {permanentCountry?.label === "India" ? (
                        <>
                          <div
                            className={` ${"col-12 col-md-6  pe-0 pe-md-2 "}`}
                          >
                            <p className="fs-16 fw-500 mb-2">GST Number</p>
                            <input
                              value={gst}
                              onChange={(e) => setGst(e.target.value)}
                              type="text"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="fs-16 fw-500 mb-2">
                              {title === "Vendor" ? "PAN Number" : "TAN Number"}
                            </p>
                            <input
                              value={tan}
                              onChange={(e) => setTan(e.target.value)}
                              type="text"
                              className="w-100 rounded custom-input px-3 py-2"
                              placeholder=""
                              required
                              autoComplete="off"
                            />
                          </div>
                        </>
                      ) : (
                        <div className={` ${"col-12  pe-0 pe-md-2 "}`}>
                          <p className="fs-16 fw-500 mb-2">TAX/VAT Number</p>
                          <input
                            value={vat}
                            onChange={(e) => setVat(e.target.value)}
                            type="text"
                            className="w-100 rounded custom-input px-3 py-2"
                            placeholder=""
                            required
                            autoComplete="off"
                          />
                        </div>
                      )}
                    </div>
                    <div className="w-100 d-flex flex-column gap-3">
                      <div className="d-flex flex-column">
                        <p className="fs-16 fw-500 mb-2">Office Location</p>
                        <Select
                          value={officeLocation}
                          onChange={(selectedOption) => {
                            const value = {
                              value: selectedOption?.value,
                              label: selectedOption?.name,
                            };
                            setOfficeLocation(value);
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              width: "100%",
                              border: "0px !important",
                              boxShadow: "0px !important",
                              backgroundColor: "#EFF6FA",
                              borderRadius: "5px",
                            }),
                          }}
                          className={`border-0 focus-none  ${officeLocation === "" && "text-para"
                            }`}
                          options={officeOptions?.map((item) => ({
                            value: item?.id,
                            label: `${item?.name} - ${truncateString(
                              item?.address_array?.address,
                              45
                            )}`,
                            name: item?.name,
                          }))}
                          placeholder=""
                          menuPlacement="top"
                        />
                      </div>

                      <div className="d-flex flex-column">
                        <p className="fs-16 fw-500 mb-2">Bank Details</p>
                        <Select
                          value={bankDetails}
                          onChange={(selectedOption) => {
                            const value = {
                              value: selectedOption?.value,
                              label: selectedOption?.name,
                            };
                            setBankDetails(value);
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              width: "100%",
                              border: "0px !important",
                              boxShadow: "0px !important",
                              backgroundColor: "#EFF6FA",
                              borderRadius: "5px",
                            }),
                          }}
                          className={`border-0 focus-none  ${bankDetails === "" && "text-para"
                            }`}
                          options={bankOptions?.map((item) => ({
                            value: item?.id,
                            label:
                              item?.name +
                              " - " +
                              truncateString(item?.branch, 25),
                            name: item?.name,
                          }))}
                          placeholder=""
                          menuPlacement="top"
                        />
                      </div>
                      <div>
                        <span className="d-flex align-items-center">
                          {enableDelayCharges ? (
                            <MdCheckBox
                              className=" c-p  text-tertiary-dark"
                              onClick={() => {
                                setEnableDelayCharges(true)
                              }}
                              size={20}
                            />
                          ) : (
                            <MdCheckBoxOutlineBlank
                              className="c-p text-tertiary-dark"
                              onClick={() => {
                                setEnableDelayCharges(false)
                              }}
                              size={20}
                            />
                          )}
                          <span
                            onClick={() => {
                              setEnableDelayCharges(!enableDelayCharges)
                            }}
                            className="fs-14 fw-400 text-tertiary-dark c-p">
                            Enable Delay charges
                          </span>
                        </span>
                      </div>
                      {enableDelayCharges && <div className={` ${"col-12  pe-0 pe-md-2 "}`}>
                        <p className="fs-16 fw-500 mb-2">Daily Interest Rate</p>
                        <input
                          value={dailyInterestRate}
                          onChange={(e) => setDailyInterestRate(e.target.value)}
                          type="text"
                          className="w-100 rounded custom-input px-3 py-2"
                          placeholder=""
                          required
                          autoComplete="off"
                        />
                      </div>}
                    </div>
                  </>
                )}

                {title === 'Vendor' &&
                  <div className="w-100 d-flex flex-column gap-3">
                    <div className="d-flex flex-column">
                      <p className="fs-16 fw-500 mb-2">Billing Office</p>
                      <Select
                        value={officeLocation}
                        onChange={(selectedOption) => {
                          const value = {
                            value: selectedOption?.value,
                            label: selectedOption?.name,
                          };
                          setOfficeLocation(value);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "100%",
                            border: "0px !important",
                            boxShadow: "0px !important",
                            backgroundColor: "#EFF6FA",
                            borderRadius: "5px",
                          }),
                        }}
                        className={`border-0 focus-none  ${officeLocation === "" && "text-para"
                          }`}
                        options={officeOptions?.map((item) => ({
                          value: item?.id,
                          label: `${item?.name} - ${truncateString(
                            item?.address_array?.address,
                            45
                          )}`,
                          name: item?.name,
                        }))}
                        placeholder=""
                        menuPlacement="top"
                      />
                    </div>
                  </div>
                }

                <div className="d-flex gap-3">
                  <Button
                    disabled={saveLoading || saveAddLoading}
                    onClick={onHide}
                    className="bg-light border-primary text-tertiary"
                  >
                    Close
                  </Button>
                  {title !== "Project" && title !== "Leave" && (
                    <Button
                      disabled={saveLoading || saveAddLoading}
                      onClick={(e) => handleSubmit(e, "saveadd")}
                      className="bg-white border-primary text-primary"
                    >
                      Save and Add New
                    </Button>
                  )}
                  <Button
                    onClick={handleSubmit}
                    disabled={saveLoading || saveAddLoading}
                    type="submit"
                    className={`text-white br-5`}
                  >
                    {saveLoading ? (
                      <span className="d-flex align-items-center">
                        <Spinner size="sm" className="me-2" />
                        Saving...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>
                </div>
              </>
            )}{" "}
          </form>
        </div>
        {show && (
          <Modal
            className="w-100 d-flex justify-content-center align-items-center"
            show={show}
          >
            <div
              className="w-100 d-flex flex-column justify-content-center align-items-center p-5 pt-4 gap-1"
              style={{ minWidth: "500px" }}
            >
              <div className="fs-20 fw-600">Do you want to send email? </div>
              {contacts?.length > 0 && (
                <div className="w-100">
                  <div className="m-3 ms-0">
                    Select Contact Options to send email:
                  </div>
                  <div className="d-flex flex-column gap-2 mb-4">
                    {contacts
                      ?.sort((a, b) => (a?.contact_type === "PRIMARY" ? -1 : 1))
                      ?.map((contact) => (
                        <label
                          key={contact.id}
                          className="d-flex align-items-center"
                        >
                          <input
                            type="checkbox"
                            value={contact?.id}
                            onChange={() => handleCheckboxChange(contact)}
                            checked={selectedContacts.some(
                              (item) => item.id === contact?.id
                            )}
                            style={{ height: "15px", width: "15px" }}
                          />
                          <span className="ms-2 c-p">{contact?.name} </span>
                          {contact.contact_type === "PRIMARY" && (
                            <div>
                              <span className="c-p ms-1 bg-primary br-5 p-1 fs-11 text-white">
                                Primary Contact
                              </span>
                            </div>
                          )}
                        </label>
                      ))}
                  </div>
                </div>
              )}
              <div className="d-flex gap-20">
                <Button
                  onClick={() => {
                    setShow(false);
                  }}
                  className="border-0 px-4"
                  style={{ backgroundColor: "#838383" }}
                >
                  Close
                </Button>
                <Button
                  onClick={() => {
                    if (selectedContacts?.length > 0) {
                      handleAddMoM(null);
                      setShow(false);
                    } else {
                      notify(
                        "Please select atleast one contact to send email",
                        "warning"
                      );
                    }
                  }}
                  className="px-4"
                >
                  Yes
                </Button>
              </div>
            </div>
          </Modal>
        )}
        {showDelete && (
          <DeleteModal
            show={showDelete}
            onHide={(e) => {
              setShowDelete(!showDelete);
            }}
            onClick={() => handleDeleteOtherContact(deleteItem)}
          />
        )}
        {showTeam && (
          <CustomAddBox
            show={showTeam}
            onHide={() => setShowTeam(false)}
            onSubmit={handleTeam}
            title="Team"
            fetchData={fetchTeamOptions}
          />
        )}
      </div>
    </div>
  );
};

export default CustomAddModal;
